var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { State, Action, Selector, Store } from '@ngxs/store';
import { StoryChaptersStateModel } from './story.chapters.state.model';
import { SetChapters, SelectChapter, NextChapter, PreviousChapter, LastChapter, FirstChapter, RemoveChapter, RecordChapterVisibilityState, ResetStoryChapters, SetChapter, RegisterChapterThumbnails, TakeChapterPicture, TakeChapterPictureSuccess, RecordChapterPaintState, SaveLiveToChapter, DuplicateChapter, CopyThumbnail, RecordChapterCamera, RecordShadowChapter, SetChapterBackground, SetAllChaptersBackground, SetSelectedChapterBackground, ResetSelectedChapterBackground, RecordChapterPickableState, RecordChapterNodeState, SelectChapterById, SetChapterModfied, ResetChaptersModfied, } from './story.chapters.actions';
import { ChapterService } from '../../chapter.service';
import { RemoveAllChapterLabels, CopyLabels } from '../labels/story.labels.actions';
import { CameraService } from 'src/app/engine/camera.service';
import { classToClass } from 'class-transformer';
import { SnapshotService } from 'src/app/engine/snapshot.service';
import { ColorRecipeModel } from 'src/app/edit/models/color-recipe.model';
import { BdGraphService } from 'src/lib/graph/graph.service';
import { EngineState } from 'src/app/engine/state/engine.state';
import { SetVisible } from 'src/app/engine/state/engine.actions';
import { StoryChapterThumbnail } from '../../models/story-chapter-thumbnail.model';
import { get, cloneDeep } from 'lodash';
import { BackgroundModel } from 'src/app/engine/models/background.model';
import { appDefaultBackground } from 'src/app/dialogs/components/background-color-dialog/background-config';
import { ThumbnailConstants } from 'src/app/shared/thumbnail.constants';
import { ImageTypeEnum } from 'src/app/shared/image.service';
import { AnimationService } from 'src/app/engine/animation.service';
// snapshot config
var defaultSnapshotConfig = {
    imageType: ImageTypeEnum.JPEG,
    copyrightEnabled: false,
    copyrightImagePath: 'assets/images/powered-by-biodigital.png',
    copyrightPosition: {
        x: 'center',
        y: 'bottom'
    },
    copyrightOffset: {
        x: 0,
        y: -15
    },
    imageQuality: 1.0
};
var initialState = {
    loading: false,
    chapters: [],
    chaptersModified: {},
    selectedChapter: null,
    shadowChapter: null,
    isChapterAnimated: false,
    thumbnails: new Map()
};
var StoryChaptersState = /** @class */ (function () {
    function StoryChaptersState(chapterService, cameraService, snapshotService, store, graphService, animationService) {
        this.chapterService = chapterService;
        this.cameraService = cameraService;
        this.snapshotService = snapshotService;
        this.store = store;
        this.graphService = graphService;
        this.animationService = animationService;
    }
    StoryChaptersState_1 = StoryChaptersState;
    /**
     * Selectors
     */
    StoryChaptersState.getStoryChapters = function (state) {
        return state.chapters;
    };
    StoryChaptersState.getSelectedChapterId = function (state) {
        return state.selectedChapter;
    };
    StoryChaptersState.getSelectedChapter = function (state) {
        return state.chapters.find(function (chapter) { return chapter.id === state.selectedChapter; }) || null;
    };
    StoryChaptersState.getSelectedChapterIndex = function (state) {
        return state.chapters.findIndex(function (chapter) { return chapter.id === state.selectedChapter; });
    };
    StoryChaptersState.getSelectedChapterModified = function (state) {
        return state.chaptersModified[state.selectedChapter] === true;
    };
    StoryChaptersState.getChapterCount = function (state) {
        return state.chapters.length;
    };
    StoryChaptersState.getRegisteredThumbnails = function (state) {
        return state.thumbnails;
    };
    StoryChaptersState.getShadowChapter = function (state) {
        return state.shadowChapter;
    };
    StoryChaptersState.getIsChapterAnimated = function (state) {
        return state.isChapterAnimated;
    };
    StoryChaptersState.getChaptersLoaded = function (state) {
        return {
            count: state.chapters.length,
            modelChapters: state.chapters.filter(function (chapter) { return chapter.readyState.model; }),
            animationChapters: state.chapters.filter(function (chapter) { return chapter.readyState.animation; })
        };
    };
    StoryChaptersState.getAllChaptersModelsReady = function (state) {
        return state.chapters.length > 0 && state.chapters.every(function (chapter) { return chapter.readyState.model; });
    };
    StoryChaptersState.getAllChaptersAnimationsReady = function (state) {
        return state.chapters.length > 0 && state.chapters.every(function (chapter) { return chapter.readyState.animation; });
    };
    StoryChaptersState.getSelectedChapterBackground = function (state) {
        var chapters = state.chapters, selectedChapter = state.selectedChapter;
        var chapter = StoryChaptersState_1.findChapter(chapters, selectedChapter);
        return get(chapter, 'background') || appDefaultBackground;
    };
    StoryChaptersState.getAllChaptersBackground = function (state) {
        return state.chapters
            .map(function (chapter) { return get(chapter, 'background'); });
    };
    StoryChaptersState.getSelectedChapterAudio = function (state) {
        var selectedChapter = state.chapters.find(function (chapter) { return chapter.id === state.selectedChapter; });
        if (selectedChapter && selectedChapter.media) {
            var media = selectedChapter.media;
            var audioClips = Object.values(media)
                .filter(function (_a) {
                var data = _a.data;
                return data.streamType === 'audio';
            });
            return audioClips[0];
        }
        else {
            return null;
        }
    };
    StoryChaptersState.findChapter = function (chapters, chapterId) {
        return chapters
            .find(function (chapter) { return chapter.id === chapterId; });
    };
    /**
     * Actions
     */
    StoryChaptersState.prototype.setChapters = function (context, action) {
        context.patchState({
            chapters: __spread(action.chapters)
        });
    };
    StoryChaptersState.prototype.setChapter = function (context, action) {
        var chapters = context.getState().chapters;
        var index = chapters.findIndex(function (_chapter) { return _chapter.id === action.chapter.id; });
        var chapter = chapters[index];
        if (JSON.stringify(chapter) !== JSON.stringify(action.chapter)) {
            chapters[index] = __assign({}, action.chapter);
            context.patchState({
                chapters: __spread(chapters)
            });
        }
    };
    StoryChaptersState.prototype.setChapterBackground = function (context, action) {
        var chapters = context.getState().chapters;
        context.patchState({
            chapters: chapters.map(function (chapter) {
                if (chapter.id === action.chapterId) {
                    chapter.background = action.background;
                }
                return chapter;
            })
        });
    };
    StoryChaptersState.prototype.setAllChaptersBackground = function (context, _a) {
        var background = _a.background;
        var chapters = context.getState().chapters;
        chapters.forEach(function (chapter) {
            chapter.background = background;
        });
        context.patchState({
            chapters: __spread(chapters)
        });
    };
    StoryChaptersState.prototype.resetSelectedChapterBackground = function (context, action) {
        var _a = context.getState(), selectedChapter = _a.selectedChapter, shadowChapter = _a.shadowChapter;
        this.store.dispatch(new SetChapterBackground(selectedChapter, shadowChapter.background));
    };
    StoryChaptersState.prototype.setSelectedChapterBackground = function (context, _a) {
        var background = _a.background;
        var chapterId = context.getState().selectedChapter;
        this.store.dispatch(new SetChapterBackground(chapterId, background));
    };
    // #NOTE: [EM] Change selected chapter id and make copy for shadowChapter
    StoryChaptersState.prototype.selectChapter = function (context, action) {
        if (!action.chapter) {
            return;
        }
        var isAnimated = this.animationService.isChapterAnimated(action.chapter);
        this.store.dispatch(new SetVisible(action.chapter ? true : false));
        context.patchState({
            selectedChapter: action.chapter ? action.chapter.id : null,
            shadowChapter: action.chapter ? classToClass(action.chapter) : null,
            isChapterAnimated: isAnimated
        });
    };
    StoryChaptersState.prototype.selectChapterById = function (context, _a) {
        var chapterId = _a.chapterId;
        this.store.dispatch(new SetVisible(true));
        context.patchState({
            selectedChapter: chapterId
        });
    };
    // Add Shadow Chapter, which captures changes to engine state, to the Story
    StoryChaptersState.prototype.saveLiveToChapter = function (context, action) {
        // identify target chapter id
        var targetChapterId = action.chapterId ? action.chapterId : context.getState().selectedChapter;
        // replace specified chapter with shadowChapter
        var shadowChapter = context.getState().shadowChapter;
        var chapters = context.getState().chapters;
        var index = chapters.findIndex(function (_chapter) { return _chapter.id === targetChapterId; });
        var targetChapter = __assign({}, chapters[index], classToClass(shadowChapter));
        targetChapter.camera.location = this.cameraService.getCamera();
        chapters[index] = targetChapter;
        this.chapterService.replaceEngineChapterWithStateChapter(chapters[index]);
        context.patchState({
            chapters: __spread(chapters)
        });
    };
    StoryChaptersState.prototype.duplicateChapter = function (context, action) {
        // create a safe chapter copy
        var copyFromShadow = action.chapter ? false : true;
        var sourceChapter = copyFromShadow ? context.getState().shadowChapter : action.chapter;
        var targetChapter = this.chapterService.copyChapter(sourceChapter);
        // insert chapter copy into ENGINE
        var chapters = context.getState().chapters;
        var insertIndex = action.location ? Math.min(action.location, chapters.length) : chapters.length;
        // #NOTE: [EM] deep copy is important. Otherwise engine replaces timeline map object.
        this.chapterService.addChapterToEngine(cloneDeep(targetChapter), insertIndex);
        // update application STATE
        chapters[insertIndex] = targetChapter;
        context.patchState({
            chapters: __spread(chapters)
        });
        context.dispatch(new CopyLabels(sourceChapter, targetChapter));
        context.dispatch(new CopyThumbnail(copyFromShadow ? null : sourceChapter, targetChapter));
    };
    StoryChaptersState.prototype.copyThumbnail = function (context, action) {
        // copy thumbnail or take new snapshot for target chapter
        var thumbnails = context.getState().thumbnails;
        var targetThumbnail = new StoryChapterThumbnail();
        if (action.sourceChapter) {
            // copy, and point snapshot to original large url
            var sourceThumbnail = thumbnails.get(action.sourceChapter.id);
            targetThumbnail = classToClass(sourceThumbnail);
            targetThumbnail.urls.small = targetThumbnail.urls.small.replace(action.sourceChapter.id, action.targetChapter.id);
            targetThumbnail.urls.large = targetThumbnail.urls.large.replace(action.sourceChapter.id, action.targetChapter.id);
            if (sourceThumbnail.snapshot) {
                targetThumbnail.snapshot = sourceThumbnail.snapshot;
            }
            else {
                targetThumbnail.snapshot = thumbnails.get(action.sourceChapter.id).urls.large;
            }
            thumbnails.set(action.targetChapter.id, targetThumbnail);
            context.patchState({
                thumbnails: new Map(thumbnails)
            });
        }
        else {
            // take a snapshot
            context.dispatch(new TakeChapterPicture(action.targetChapter.id));
        }
    };
    StoryChaptersState.prototype.nextChapter = function (context, action) {
        var chapters = context.getState().chapters;
        var currentChapterId = this.chapterService.getCurrentChapterId();
        var index = 0;
        index = chapters.findIndex(function (chapter) { return chapter.id === currentChapterId; });
        if (index < chapters.length - 1) {
            index++;
        }
        context.dispatch(new SelectChapter(chapters[index]));
    };
    StoryChaptersState.prototype.previousChapter = function (context, action) {
        var chapters = context.getState().chapters;
        var currentChapterId = this.chapterService.getCurrentChapterId();
        var index = 0;
        index = chapters.findIndex(function (chapter) { return chapter.id === currentChapterId; });
        if (index > 0) {
            index--;
        }
        context.dispatch(new SelectChapter(chapters[index]));
    };
    StoryChaptersState.prototype.lastChapter = function (context, action) {
        var chapters = context.getState().chapters;
        context.dispatch(new SelectChapter(chapters[chapters.length - 1]));
    };
    StoryChaptersState.prototype.firstChapter = function (context, action) {
        var chapters = context.getState().chapters;
        context.dispatch(new SelectChapter(chapters[0]));
    };
    StoryChaptersState.prototype.removeChapter = function (context, action) {
        var _a = context.getState(), chapters = _a.chapters, selectedChapter = _a.selectedChapter;
        // Don't allow the user to remove the last chapter,
        // or else the system will break. 
        if (chapters.length === 1) {
            return;
        }
        // Trigger a rebuild of the chapter object in the engine before updating the application. 
        this.chapterService.removeChapterFromEngine(action.chapter);
        // Update chapters array
        var chapterIndex = chapters.findIndex(function (chapter) { return chapter.id === action.chapter.id; });
        chapters.splice(chapterIndex, 1);
        context.patchState({
            chapters: __spread(chapters)
        });
        // Selected chapter deleted, need to select a new chapter by default
        if (action.chapter.id === selectedChapter) {
            // Make sure selected chapter doesn't exceed chapter array size
            if (chapterIndex === chapters.length) {
                chapterIndex--;
            }
            context.dispatch(new SelectChapter(chapters[chapterIndex]));
        }
        // Nuke all chapter labels
        context.dispatch(new RemoveAllChapterLabels(action.chapter));
    };
    StoryChaptersState.prototype.resetStoryChaptersState = function (context, action) {
        context.setState(initialState);
    };
    StoryChaptersState.prototype.recordShadowChapter = function (context, action) {
        context.patchState({
            shadowChapter: classToClass(action.chapter)
        });
    };
    StoryChaptersState.prototype.recordChapterVisibilityState = function (context, action) {
        this.store.dispatch(new RecordChapterNodeState(action.nodes, { 'shown': action.visible }, action.record));
    };
    // record chagnes to shadowObject and conditionally to current chapter
    StoryChaptersState.prototype.recordChapterPaintState = function (context, action) {
        var _this = this;
        // get shadow chapter
        var shadowChapter = context.getState().shadowChapter;
        // get view graph and filter nodes for subsumption (deeper nodes subsumed by shallower nodes)
        var viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
        var accessorIds = this.graphService.filterGraphAccessors(viewGraph, action.nodes.map(function (node) { return node.id; }));
        // update the state record of chapter. Clear color mods beneath accessors, so they do not block this paint state
        var chapterSync = shadowChapter.synchronization;
        accessorIds.forEach(function (id) {
            // clear color mods on deeper nodes in the graph
            chapterSync = _this.chapterService.clearColorModsFromSync(chapterSync, _this.graphService.getDescendants(viewGraph, id));
            // set the synchronization on the subsuming accessor
            chapterSync[id] = __assign({}, chapterSync[id] || {}, ColorRecipeModel.toEngine(action.paintState));
        });
        // update the engine's record
        shadowChapter.synchronization = __assign({}, chapterSync); // needs new object
        // patch state with updated stateful chapter record
        context.patchState({
            shadowChapter: classToClass(shadowChapter)
        });
        // conditionally save with current story chapter
        if (action.record) {
            var chapters = context.getState().chapters;
            var currentChapterId_1 = context.getState().selectedChapter;
            var currentChapterIndex = chapters.findIndex(function (_chapter) { return _chapter.id === currentChapterId_1; });
            var chapter = chapters[currentChapterIndex];
            this.chapterService.updateChapterSynchronization(chapter.id, shadowChapter.synchronization);
            chapter.synchronization = __assign({}, shadowChapter.synchronization);
            context.patchState({
                chapters: __spread(chapters)
            });
        }
    };
    StoryChaptersState.prototype.recordChapterCamera = function (context, action) {
        var camera = __assign({}, action.camera);
        // get shadow chapter
        var shadowChapter = context.getState().shadowChapter;
        // record change on shadow chapter if it matches the chapter being changed
        if (shadowChapter.id === action.chapter.id) {
            shadowChapter.camera.location = camera;
            // patch state with updated stateful chapter record
            context.patchState({
                shadowChapter: classToClass(shadowChapter)
            });
        }
        // conditionally save with current story chapter
        if (action.record) {
            var chapters = context.getState().chapters;
            var currentChapterIndex = chapters.findIndex(function (_chapter) { return _chapter.id === action.chapter.id; });
            var chapter = chapters[currentChapterIndex];
            if (action.chapter.id === shadowChapter.id) {
                this.chapterService.updateChapterSynchronization(chapter.id, shadowChapter.synchronization);
            }
            chapter.camera.location = __assign({}, action.camera);
            context.patchState({
                chapters: __spread(chapters)
            });
        }
    };
    StoryChaptersState.prototype.recordChapterPickableState = function (context, action) {
        this.store.dispatch(new RecordChapterNodeState(action.nodes, { 'pickable': action.pickable }, action.record));
    };
    StoryChaptersState.prototype.recordChapterNodeState = function (context, action) {
        var _this = this;
        // get shadow chapter
        var shadowChapter = context.getState().shadowChapter;
        // get view graph and filter nodes for subsumption (deeper nodes subsumed by shallower nodes)
        var viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
        var accessorIds = this.graphService.filterGraphAccessors(viewGraph, action.nodes.map(function (node) { return node.id; }));
        // update shadow chapter synchronzation
        var chapterSync = shadowChapter.synchronization;
        accessorIds.forEach(function (id) {
            Object.entries(action.stateMap).forEach(function (_a) {
                var _b;
                var _c = __read(_a, 2), propName = _c[0], propValue = _c[1];
                // clear color mods on deeper nodes in the graph
                chapterSync = _this.chapterService.clearBoolStateFromSync(chapterSync, _this.graphService.getDescendants(viewGraph, id), propName);
                // set the synchronization on the subsuming accessor
                chapterSync[id] = __assign({}, chapterSync[id] || {}, (_b = {}, _b[propName] = propValue, _b));
            });
        });
        // patch state with updated stateful chapter record
        context.patchState({
            shadowChapter: classToClass(shadowChapter)
        });
        // conditionally save with current story chapter
        if (action.record) {
            var chapters = context.getState().chapters;
            var currentChapterId_2 = context.getState().selectedChapter;
            var currentChapterIndex = chapters.findIndex(function (_chapter) { return _chapter.id === currentChapterId_2; });
            var chapter = chapters[currentChapterIndex];
            this.chapterService.updateChapterSynchronization(chapter.id, shadowChapter.synchronization);
            chapter.synchronization = __assign({}, shadowChapter.synchronization);
            context.patchState({
                chapters: __spread(chapters)
            });
        }
    };
    StoryChaptersState.prototype.registerChapterThumbnails = function (context, action) {
        // urls that came with scene for managing and housekeeping of server thumbnails per chapter
        context.patchState({
            thumbnails: new Map(action.thumbnails)
        });
    };
    StoryChaptersState.prototype.takeChapterSnapshot = function (context, _a) {
        var chapterId = _a.chapterId, includeLabels = _a.includeLabels, includeCopyright = _a.includeCopyright, dimensions = _a.dimensions;
        // get target dimensions: fallback to default
        var snapshotDimensions = dimensions ? dimensions : ThumbnailConstants.large;
        var width = snapshotDimensions.width, height = snapshotDimensions.height;
        // get selected background
        var selectedBackground = this.store.selectSnapshot(StoryChaptersState_1.getSelectedChapterBackground);
        var snapshotBackground = selectedBackground && !BackgroundModel.isTransparent(selectedBackground) ? selectedBackground : appDefaultBackground;
        var snapshotConfig = __assign({}, defaultSnapshotConfig, { copyrightEnabled: includeCopyright });
        this.snapshotService.takeSnapshot(width, height, snapshotBackground, includeLabels, snapshotConfig).subscribe(function (blob) {
            context.dispatch(new TakeChapterPictureSuccess(chapterId, blob, snapshotDimensions));
        });
    };
    StoryChaptersState.prototype.takeChapterSnapshotSuccess = function (context, action) {
        var thumbnails = context.getState().thumbnails;
        var thumbnail = thumbnails.get(action.chapterId) || new StoryChapterThumbnail();
        thumbnail.snapshot = URL.createObjectURL(action.blob);
        thumbnails.set(action.chapterId, thumbnail);
        context.patchState({
            thumbnails: new Map(thumbnails)
        });
    };
    StoryChaptersState.prototype.setChaptersModfied = function (context, _a) {
        var _b;
        var chapterId = _a.chapterId, modified = _a.modified;
        var chapterModified = context.getState().chaptersModified;
        context.patchState({
            chaptersModified: __assign({}, chapterModified, (_b = {}, _b[chapterId] = modified, _b))
        });
    };
    StoryChaptersState.prototype.ResetChaptersModfied = function (context, action) {
        context.patchState({
            chaptersModified: {}
        });
    };
    var StoryChaptersState_1;
    __decorate([
        Action(SetChapters),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetChapters]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState.prototype, "setChapters", null);
    __decorate([
        Action(SetChapter),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetChapter]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState.prototype, "setChapter", null);
    __decorate([
        Action(SetChapterBackground),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetChapterBackground]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState.prototype, "setChapterBackground", null);
    __decorate([
        Action(SetAllChaptersBackground),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState.prototype, "setAllChaptersBackground", null);
    __decorate([
        Action(ResetSelectedChapterBackground),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ResetSelectedChapterBackground]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState.prototype, "resetSelectedChapterBackground", null);
    __decorate([
        Action(SetSelectedChapterBackground),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState.prototype, "setSelectedChapterBackground", null);
    __decorate([
        Action(SelectChapter),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SelectChapter]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState.prototype, "selectChapter", null);
    __decorate([
        Action(SelectChapterById),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState.prototype, "selectChapterById", null);
    __decorate([
        Action(SaveLiveToChapter),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SaveLiveToChapter]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState.prototype, "saveLiveToChapter", null);
    __decorate([
        Action(DuplicateChapter),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, DuplicateChapter]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState.prototype, "duplicateChapter", null);
    __decorate([
        Action(CopyThumbnail),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, CopyThumbnail]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState.prototype, "copyThumbnail", null);
    __decorate([
        Action(NextChapter),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, NextChapter]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState.prototype, "nextChapter", null);
    __decorate([
        Action(PreviousChapter),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, PreviousChapter]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState.prototype, "previousChapter", null);
    __decorate([
        Action(LastChapter),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, LastChapter]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState.prototype, "lastChapter", null);
    __decorate([
        Action(FirstChapter),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, LastChapter]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState.prototype, "firstChapter", null);
    __decorate([
        Action(RemoveChapter),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, RemoveChapter]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState.prototype, "removeChapter", null);
    __decorate([
        Action(ResetStoryChapters),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ResetStoryChapters]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState.prototype, "resetStoryChaptersState", null);
    __decorate([
        Action(RecordShadowChapter),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, RecordShadowChapter]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState.prototype, "recordShadowChapter", null);
    __decorate([
        Action(RecordChapterVisibilityState),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, RecordChapterVisibilityState]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState.prototype, "recordChapterVisibilityState", null);
    __decorate([
        Action(RecordChapterPaintState),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, RecordChapterPaintState]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState.prototype, "recordChapterPaintState", null);
    __decorate([
        Action(RecordChapterCamera),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, RecordChapterCamera]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState.prototype, "recordChapterCamera", null);
    __decorate([
        Action(RecordChapterPickableState),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, RecordChapterPickableState]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState.prototype, "recordChapterPickableState", null);
    __decorate([
        Action(RecordChapterNodeState),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, RecordChapterNodeState]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState.prototype, "recordChapterNodeState", null);
    __decorate([
        Action(RegisterChapterThumbnails),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, RegisterChapterThumbnails]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState.prototype, "registerChapterThumbnails", null);
    __decorate([
        Action(TakeChapterPicture),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, TakeChapterPicture]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState.prototype, "takeChapterSnapshot", null);
    __decorate([
        Action(TakeChapterPictureSuccess),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, TakeChapterPictureSuccess]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState.prototype, "takeChapterSnapshotSuccess", null);
    __decorate([
        Action(SetChapterModfied),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetChapterModfied]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState.prototype, "setChaptersModfied", null);
    __decorate([
        Action(ResetChaptersModfied),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ResetChaptersModfied]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState.prototype, "ResetChaptersModfied", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [StoryChaptersStateModel]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState, "getStoryChapters", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [StoryChaptersStateModel]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState, "getSelectedChapterId", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [StoryChaptersStateModel]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState, "getSelectedChapter", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [StoryChaptersStateModel]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState, "getSelectedChapterIndex", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [StoryChaptersStateModel]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState, "getSelectedChapterModified", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [StoryChaptersStateModel]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState, "getChapterCount", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [StoryChaptersStateModel]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState, "getRegisteredThumbnails", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [StoryChaptersStateModel]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState, "getShadowChapter", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [StoryChaptersStateModel]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState, "getIsChapterAnimated", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [StoryChaptersStateModel]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState, "getChaptersLoaded", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [StoryChaptersStateModel]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState, "getAllChaptersModelsReady", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [StoryChaptersStateModel]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState, "getAllChaptersAnimationsReady", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [StoryChaptersStateModel]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState, "getSelectedChapterBackground", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [StoryChaptersStateModel]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState, "getAllChaptersBackground", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [StoryChaptersStateModel]),
        __metadata("design:returntype", void 0)
    ], StoryChaptersState, "getSelectedChapterAudio", null);
    StoryChaptersState = StoryChaptersState_1 = __decorate([
        State({
            name: 'storyChapters',
            defaults: initialState
        }),
        __metadata("design:paramtypes", [ChapterService,
            CameraService,
            SnapshotService,
            Store,
            BdGraphService,
            AnimationService])
    ], StoryChaptersState);
    return StoryChaptersState;
}());
export { StoryChaptersState };
